export default __webpack_public_path__ + "static/media/card-active-transparent.83d0d75c.svg";